export const compressorOptions = {
    maxSizeMB: 0.125, // Maximum size in megabytes (125 KB in this case)
    maxWidthOrHeight: 300, // Adjust the maximum width or height as needed
    useWebWorker: true
};
export const MAX_FILE_SIZE = 5120;
export const MAX_FILE_CONTENT = '5MB';
